import { atom, selector, waitForNone } from 'recoil';
import { localStorageEffect } from '../effects';
import { isReportState, LayoutVersion, layoutVersionState, SCALE_FACTOR } from '../studio';

export enum PageLayout {
  /** Vertical scrolling pages */
  VERTICAL,
  /** Horizontal scrolling pages */
  HORIZONTAL,
  /** Vertical scrolling pages with two pages side by side */
  COLUMNS,
}

export const gridScaleFactorState = selector({
  key: 'gridScaleFactorState',
  get: ({ get }) => {
    return get(layoutVersionState) === LayoutVersion.MODERN || !get(isReportState) ? 1 : SCALE_FACTOR;
  },
});

/** The total transform on the grid of blocks, including handling of Zoom and other scaling. Also usable in Studio, where it will always return 1. */
export const gridTransformScaleState = selector<number>({
  key: 'gridTransformScaleState',
  get: ({ get }) => {
    const [isReportLoadable] = get(waitForNone([isReportState]));
    if (!isReportLoadable.valueMaybe()) return 1;

    const scaleFactor = get(gridScaleFactorState);
    const zoom = get(reportZoom);
    return zoom * scaleFactor;
  },
});

/** Zoom in report lab. Be careful if you use this in Studio, as Studio doesn't have zoom applied, but this will still return the report lab zoom value. */
export const reportZoom = atom<number>({
  key: 'reportZoom',
  default: 1,
  effects: [localStorageEffect('report_zoom')],
});

export const reportPageLayout = atom<PageLayout>({
  key: 'reportPageLayout',
  default: PageLayout.VERTICAL,
  effects: [localStorageEffect('report_page_layout')],
});
